import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export function Navigation({ onLogoClick, onNavClick }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const links = [
    { href: '#accueil', label: 'ACCUEIL' },
    { href: '#services', label: 'SERVICES' },
    { href: '#projets', label: 'PROJETS' },
    { href: '#contact', label: 'CONTACT' },
  ];

  const handleNavClick = (href) => {
    if (onNavClick) {
      onNavClick(href);
    } else {
      window.location.hash = href;
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white border-b-4 border-black">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <img
            src={require('../assets/images/clip-web-logo.png')}
            alt="Clip Web Logo"
            className="h-20 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={onLogoClick}
          />
          {/* <div
            className="text-2xl font-black tracking-tight cursor-pointer hover:text-cyan-500 transition-colors"
            onClick={onLogoClick}
          >
            CLIP WEB
          </div> */}

          {/* Desktop */}
          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className="font-bold hover:text-cyan-500 transition-colors bg-none border-none cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('#contact')}
              className="bg-orange-600 text-white px-6 py-3 font-black border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all cursor-pointer"
            >
              DEMANDER UN DEVIS
            </button>
          </div>

          {/* Mobile burger */}
          <button
            className="md:hidden border-4 border-black p-2 bg-yellow-300 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-x-1 active:translate-y-1 transition-all"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden mobile-menu-open mt-4 border-4 border-black bg-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]">
            {links.map((link) => (
              <button
                key={link.href}
                onClick={() => {
                  handleNavClick(link.href);
                  setMobileOpen(false);
                }}
                className="w-full text-left px-6 py-4 font-black border-b-2 border-black last:border-b-0 hover:bg-cyan-400 transition-colors bg-none border-none cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => {
                handleNavClick('#contact');
                setMobileOpen(false);
              }}
              className="w-full text-left px-6 py-4 font-black bg-orange-600 text-white hover:bg-orange-700 transition-colors border-none cursor-pointer"
            >
              DEMANDER UN DEVIS
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
